export interface ShareFeedbackState {
  message: string;
  url?: string;
}

interface Props {
  feedback: ShareFeedbackState | null;
  onDismiss: () => void;
}

export function ShareFeedback({ feedback, onDismiss }: Props) {
  if (!feedback) return null;

  return (
    <aside className="share-feedback" aria-labelledby="share-feedback-title">
      <div className="share-feedback__copy">
        <span className="section-kicker">Share</span>
        <p id="share-feedback-title" role="status" aria-live="polite">
          {feedback.message}
        </p>
      </div>
      <button
        className="share-feedback__dismiss"
        aria-label="Dismiss share message"
        onClick={onDismiss}
      >
        <span aria-hidden="true">×</span>
      </button>
      {feedback.url && (
        <label className="share-feedback__link">
          <span>Share link</span>
          <input
            readOnly
            value={feedback.url}
            onFocus={(event) => event.currentTarget.select()}
          />
        </label>
      )}
    </aside>
  );
}
